import React from "react";
const processingContext = React.createContext();
export default processingContext;
